var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ListItem", {
    attrs: {
      "is-recipient": "",
      info: "",
      message: _vm.message,
      "force-sender-display": true
    },
    scopedSlots: _vm._u([
      {
        key: "text",
        fn: function() {
          return [
            _c("b", [_vm._v("Wir bitten um die Zusendung eines Lebenslaufs.")])
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }